import React from "react";
import { Link } from "react-router-dom";
import { useRoleVerify } from "Common/RoleVerify";
import { GetPageUrl } from "utils/CommonUtils";
import Tooltip from "Common/Custom/Tooltip";

const EditBtn = ({ url, disabled, name }) => {
  console.log("disabled", disabled)
  const page_url = GetPageUrl()
  let Isdisabled = false
  if (Number(disabled) > 0) {
    Isdisabled = true
  }
  return (
    useRoleVerify('', ["can_edit"]) && (
      <Tooltip text="Edit" position="top">
        <Link to={!Isdisabled ? `/admin/${page_url}/${url}` : "#"} className={`btn btn-primary btn-sm border me-1 rounded-2 ${Isdisabled ? 'disabled' : ''} `} aria-label="Edit">
          {name ?
            name :
            <svg xmlns="http://www.w3.org/2000/svg" width={20} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" className="svg-stroke">
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1" />
              <path d="M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z" />
              <path d="M16 5l3 3" />
            </svg>
          }
        </Link>
      </Tooltip>
    )
  );
};

export default EditBtn;
